import {
    type CustomFieldOption,
    CustomFieldWithAssociations
} from '@he-novation/config/types/custom-field.types';
import { CustomFieldAssociationType } from '@he-novation/config/types/db/enums';
import { atom, useAtomValue } from 'jotai';

export const customFieldsAtom = atom<CustomFieldWithAssociations[]>([]);

export function useCustomField(type: CustomFieldAssociationType, name: string) {
    const customFields = useAtomValue(customFieldsAtom);
    return customFields.find(
        (customField) =>
            customField.associations.find((a) => a.type === type) &&
            customField.name.toLowerCase().includes(name.toLowerCase())
    );
}

export function useCustomFieldOptions(
    type: CustomFieldAssociationType,
    name: string
): CustomFieldOption[] {
    const customField = useCustomField(type, name);
    return customField?.options || [];
}

export function useAssociationCustomFields(type: CustomFieldAssociationType) {
    const customFields = useAtomValue(customFieldsAtom);
    return customFields.filter(
        (customField) =>
            customField.associations.some((a) => a.type === type) && !customField.managed
    );
}
